import { SET_BROWSER } from "./setBrowserConstants";

export const setBrowser = (browser) => {
  return {
    type: SET_BROWSER,
    payload: browser,
  };
};
